import yup, { cardNameValidator, stringValidator } from '~/utils/validators.yup';

export const schema = () =>
    yup.object({
        name: cardNameValidator(),
        description: stringValidator.required(),
    });

export const initialValues = { name: '', description: '' };
